import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Grand%20Chinese%20traditional%20stage%20with%20warm%20red%20and%20gold%20curtains%20and%20dramatic%20spotlight%20effects%2C%20elegant%20performance%20venue%20with%20ornate%20decorations%2C%20rich%20artistic%20atmosphere%2C%20professional%20wide%20angle%20photography%20with%20soft%20theatrical%20lighting%2C%20empty%20stage%20ready%20for%20performance&width=1600&height=900&seq=hero-bg-ds&orientation=landscape"
        alt="东升大舞台演艺平台"
        title="东升大舞台 - 精彩演艺内容平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full text-center px-4">
        <div className="max-w-3xl mx-auto">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight">
            东升大舞台
          </h1>
          <p className="text-base md:text-xl text-white/90 mb-8 leading-relaxed max-w-2xl mx-auto">
            精彩演艺内容一站式平台，汇集歌舞、戏曲、相声、魔术等多元表演艺术，随时随地畅享视听盛宴
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#download"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-white rounded-md text-base font-semibold whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
            >
              <i className="ri-android-line text-lg"></i>
              安卓下载
            </a>
            <a
              href="#download"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-white/15 backdrop-blur-sm text-white border border-white/30 rounded-md text-base font-semibold whitespace-nowrap cursor-pointer hover:bg-white/25 transition-colors"
            >
              <i className="ri-apple-line text-lg"></i>
              iOS下载
            </a>
          </div>
          <p className="mt-6 text-sm text-white/60">
            当前最新版本：V3.5 | 已通过安全检测 | 完全免费下载
          </p>
        </div>
      </div>
    </section>
  );
}